import { useMemo } from 'react';
import { DataDetailCheckout } from '../types';

export const usePaymentStatus = (data: DataDetailCheckout): boolean => {
  return useMemo(() => {
    if (!data) return false;

    const mainStatus = data.status;
    return String(mainStatus).toUpperCase() === 'ACTIVE';
  }, [data]);
};
